import { useDispatch, useSelector } from "react-redux";
import { useForm } from 'react-hook-form';
import { CLIENT, SERVICE, SERVICEALL, USER, CATEGORYALL } from "../../services/actions";
import { useNavigate } from "react-router-dom";
import React from "react";
import { Button, Container, Box, Grid, Tab, Tabs, Pagination, Avatar, Typography, Card, Stack } from "@mui/material";
import MyCard from "../extra/Card";
import { BsFilePlusFill } from "react-icons/bs";
import Form from './Form';
import ActionBar from "../extra/ActionBar";
import ProjectImg from './project.jpg'
import SearchBar from "../extra/SearchBar";
import { isBase64Image, seedData } from "../../libs/Libs";
import XTable from "../extra/XTableAnother";
import MoreInfo from "../extra/MoreInfo";
import { BsCopy, BsListTask } from "react-icons/bs";
import NoData from "../extra/NoData";

export default function View() {
  let dispatch = useDispatch()
  const [open, setOpen] = React.useState(false)
  const [defV, setDefV] = React.useState({})
  const [view, setView] = React.useState(1);
  const navigate = useNavigate();
  let ref = React.createRef()
  let ref2 = React.createRef()
  let serviceState = useSelector((state) => state?.serviceState)
  let serviceallState = useSelector((state) => state?.serviceallState)
  let clientState = useSelector((state) => state?.clientState)
  let categoryallState = useSelector((state) => state?.categoryallState)
  const [companies, setCompanies] = React.useState([])
  const [categories, setCategories] = React.useState([])
  let user = useSelector((state) => state?.loginState?.auth)
  const [page, setPage] = React.useState(0); // current page  
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchServices = (page = 0) => {
    const url = page === 0 ? `service/${page}/` : `service/?page=${page}`;// pass page number    
    dispatch({ type: `${SERVICE}_GET`, payload: url });
    dispatch({ type: `${SERVICEALL}_GET`, payload: url });
  }

  React.useEffect(() => {
    try {
      console.log("Company List", user)
      //dispatch({ type: `${PROJECTALL}_GET`, payload: 0 })
      fetchServices(0);
      dispatch({ type: `${CATEGORYALL}_GET`, payload: 'category/' })
      // dispatch({ type: `${COMPANY}_GET`, payload: 0 })
    } catch (err) {
    }
  }, [])

  React.useEffect(() => {
    // fetchProjects(page);
  }, [page]);

  React.useEffect(() => {
    setCompanies(clientState?.data?.results)
  }, [clientState?.data])
  React.useEffect(() => {
    console.log("DATA", serviceState)
    if (serviceState?.success) {
      setOpen(!serviceState?.success)
      dispatch({ type: `${SERVICEALL}_GET`, payload: 0 })
    }

  }, [serviceState?.data])

  React.useEffect(() => {
    setCategories(categoryallState?.data?.results || categoryallState?.data || [])
  }, [categoryallState?.data])

  // Handle filter search
  const handleSearch = (key, value) => {
    const query = `service/0/?filter_by={"${key}__istartswith":"${value}"}`;
    dispatch({ type: `${SERVICEALL}_GET`, payload: query });
  };
  const tableHeadings = ["ID", "image", "Project Name", "Company Name", "Country", "Duration", "Camera Count"];
  const tableRows = serviceallState?.data?.results?.map((project) => ({
    id: project.id,
    image: project.project_image,
    project_name: project.project_name,
    company_name: project.company_name,
    country: project.country,
    duration: project.duration,
    camera_count: project.camera_count,


  }));

  const handleDelete = (id) => {
    dispatch({ type: `${SERVICE}_DELETE`, payload: id });
  };

  return (
    <>

      {open ? <div>

        <Form companies={companies} categories={categories}
          defaultValues={defV}

          onSubmit={(data) => {
            if (!isBase64Image(data.image)) {
              delete data["image"]
            }

            let action = data.id ? `${SERVICE}_PATCH` : `${SERVICE}_POST`
            dispatch({ type: action, payload: data })
          }}
          back={() => { setOpen(false) }}
        /></div>
        : <Container maxWidth="false" className="py-3">
          <Box className="card-bg" sx={{ my: 2, py: 0.2, px: 2, borderRadius: 1 }}>
            <ActionBar
              showGrid={[2, 5]}
              onBtnClick={(type, col) => {
                if (type === "grid") {
                  setView(1);
                }
                if (type === "tabular") {
                  setView(2);
                }
              }}
              hasPermission={user.permissions.includes('services.add_service')}
              label="Services"
              setOpen={(s) => {
                if (user.main_role == "Company") {
                  setCompanies(user?.companies)
                } else {
                  // dispatch({ type: `${COMPANY}_GET`, payload: 0 })
                }
                setDefV({});
                setOpen(true);

              }}
              btnLabel="ADD SERVICES" />
          </Box>
          <SearchBar bylist={["service_name"]} handleSearch={handleSearch} />
          {view === 1 && (
            <>
              {serviceallState?.loading ? (
                <NoData loading={true} loadingTitle="Loading Services..." loadingMessage="Please wait while we fetch service records." />
              ) : !serviceallState?.data?.results || serviceallState?.data?.results?.length === 0 ? (
                <NoData title="No Services Found" message="There are currently no services to display. Try adjusting your search or add a new service." />
              ) : (
                <>
                  <Grid container spacing={1}>
                    {serviceallState?.data?.results?.map((data, idx) => {
                      return <Grid alignItems="stretch" size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }}>
                        <MyCard
                          title={data?.service_name}
                          subtitle={
                            <Box display="flex" alignItems="center" gap={0.8}>
                              <Box sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 0.6,
                                px: 1.4,
                                py: 0.35,
                                bgcolor: '#eff6ff',
                                color: '#1d4ed8',
                                borderRadius: '20px',
                                border: '1px solid #bfdbfe',
                                fontSize: '11.5px',
                                fontWeight: 700,
                                boxShadow: '0 1px 2px rgba(37, 99, 235, 0.06)'
                              }}>
                                <BsListTask size={13} color="#2563eb" />
                                <span>{`Associated Tasks: ${data?.category ?? 0}`}</span>
                              </Box>
                            </Box>
                          }
                          onAction={(action) => {
                            if ("more-info" === action) {
                              navigate("/more-info/", { state: { data, title: "Service", prevNav: '/services/' } })
                            } else if ("edit" === action) {
                              setDefV(data)
                              setOpen(true)
                            } else if ("delete" === action) {
                              handleDelete(data?.id)
                            }

                          }}
                        >
                          <Stack spacing={1.5} sx={{ mt: 1 }}>
                            <Box sx={{ p: 1.5, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #f1f5f9' }}>
                              <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={600}>
                                  TAT - in Days
                                </Typography>
                                <Typography fontWeight={700} color="#1e293b" fontSize={12}>
                                  {data.tat_days} Days
                                </Typography>
                              </Box>

                              <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={600}>
                                  TAT - in Hours
                                </Typography>
                                <Typography fontWeight={700} color="#1e293b" fontSize={12}>
                                  {data.tat_hours} Hours
                                </Typography>
                              </Box>

                              <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={600}>
                                  Professional Fee
                                </Typography>
                                <Typography fontWeight={700} color="#3b82f6" fontSize={13}>
                                  {data.professional_fee}
                                </Typography>
                              </Box>
                            </Box>
                          </Stack>

                          <Box mt={1.5}>
                            <Typography color="#64748b" fontSize={12} lineHeight={1.6} sx={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                              {data.description}
                            </Typography>
                          </Box>

                          {/* Buttons */}
                          <Box mt="auto" pt={2.5} display="flex" justifyContent="center">
                            <Button
                              variant="contained"
                              sx={{
                                borderRadius: "8px",
                                py: 0.7,
                                px: 2.5,
                                fontSize: "13px",
                                textTransform: "none",
                                fontWeight: 600,
                                boxShadow: "0 4px 6px -1px rgb(59 130 246 / 0.3)",
                                backgroundColor: "#3b82f6",
                                "&:hover": {
                                  backgroundColor: "#2563eb",
                                  boxShadow: "0 6px 12px -2px rgb(59 130 246 / 0.4)",
                                }
                              }}
                              onClick={() => {
                                navigate("/services-tasks/", { state: { data: data, prevNav: "/services/" } })
                              }}
                            >
                              Add/View Tasks
                            </Button>
                          </Box>

                        </MyCard>
                      </Grid>
                    })}
                  </Grid>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Pagination
                      count={Math.ceil(serviceallState?.data?.count / pageSize)}
                      page={page}
                      onChange={(e, value) => setPage(value)}
                      color="primary"
                    />
                  </Box>
                </>
              )}
            </>
          )}
          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}
              onEdit={(row) => {
                // Find the original project data from the full results
                const originalData = serviceallState?.data?.results.find(
                  (project) => project.id === row.id
                );

                // Set the form's default values and open the form
                if (originalData) {
                  setDefV(originalData);
                  setOpen(true);
                }
              }}
              onDelete={handleDelete}
            />
          )}
          {view === 4 && <MoreInfo
            data={{
              ...defV,
              active: defV.active ? "Yes" : "No",
              verify: defV.verify ? "Yes" : "No",
            }}

            skip={['country', 'description', 'error_email', 'no_users', 'owner', 'image']}
            group={['', 'project_name', 'created_at',]}
            icons={{ project_image: <BsCopy /> }}
            css={{ project_image: { color: '#1976d2' } }}
            onClose={() => { setView(1) }} />}

        </Container>}

    </>
  )
}